import { Reveal } from "@/components/yanre/Reveal";
import { useLocale } from "@/i18n/LocaleContext";

// SECTION — Direct From The Manufacturer. YANRE positioned as the factory.
const POINTS = [
  ["pts.direct.p0", "Commercial-grade equipment"],
  ["pts.direct.p1", "Direct manufacturer relationship"],
  ["pts.direct.p2", "Factory-backed warranty"],
  ["pts.direct.p3", "International logistics support"],
  ["pts.direct.p4", "Project consulting"],
  ["pts.direct.p5", "After-sales support"],
];

export const PTDirect = () => {
  const { t } = useLocale();
  return (
    <section className="section-darker py-24 lg:py-32" data-testid="pt-direct-section">
      <div className="container-edge grid gap-12 lg:grid-cols-2 lg:items-center">
        <div>
          <Reveal>
            <div className="mb-6 flex items-center gap-4">
              <span className="h-px w-10 bg-signal" />
              <span className="overline">{t("pts.direct.label", "Direct From The Manufacturer")}</span>
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
              {t("pts.direct.h2a", "No middlemen.")}{" "}
              <span className="text-signal">{t("pts.direct.h2b", "No compromises.")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base font-light leading-relaxed text-titanium/75 sm:text-lg" data-testid="pt-direct-copy">
              {t(
                "pts.direct.copy",
                "YANRE is the manufacturer — engineering and producing its own commercial-grade equipment since 1997. Your project, your equipment contract and your warranty live directly with the factory that builds your machines."
              )}
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 gap-px border border-carbon-700 bg-carbon-700 sm:grid-cols-2" data-testid="pt-direct-grid">
          {POINTS.map(([key, fallback], i) => (
            <Reveal key={key} delay={0.05 * i}>
              <div className="flex h-full items-center gap-3 bg-carbon-950 p-6" data-testid={`pt-direct-point-${i}`}>
                <span className="h-1.5 w-1.5 shrink-0 bg-signal" />
                <span className="font-display text-base font-bold uppercase tracking-wide text-white">{t(key, fallback)}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
